import { useState } from 'react';
import { EventsList, TaskEventsList, useEventsList } from '.';
import { ErrorBanner } from 'shared/ui/error-banner';

interface EventsListTabProps {
  tab: string;
  checkedItems: number[];
  setCheckedItems: (updater: number[] | ((prev: number[]) => number[])) => void;
  searchParams: URLSearchParams;
}

export const EventsListTab = ({ tab, checkedItems, setCheckedItems, searchParams }: EventsListTabProps) => {
  const queryKey = `${tab}?${searchParams.toString()}`;
  const [paging, setPaging] = useState({ queryKey, page: 0 });
  const page = paging.queryKey === queryKey ? paging.page : 0;
  if (paging.queryKey !== queryKey) {
    setPaging({ queryKey, page: 0 });
  }

  const { collection, isLoading, error } = useEventsList(tab, page, searchParams);

  if (error) return <ErrorBanner errorMessage={error} />;

  const handleCheckChange = (id: number, checked: boolean) => {
    setCheckedItems((prev) => (checked ? [...prev, id] : prev.filter((itemId) => itemId !== id)));
  };

  const handleLoadMore = () => {
    if (!isLoading) {
      setPaging({ queryKey, page: page + 1 });
    }
  };
  if (tab === 'events') {
    return <EventsList collection={collection} isLoading={isLoading} loadMore={handleLoadMore} showCompany={true} />;
  }

  return (
    <TaskEventsList collection={collection} isLoading={isLoading} loadMore={handleLoadMore} showCompany={true} checkedItems={checkedItems} handleCheckChange={handleCheckChange} />
  );
};
